/* global Forms */

import ApplicationController from '../application_controller'

const SALARY_PAYMENT_TYPES = ['salary', 'hourly_wage']
const RECURRENT_INTERVALS = ['monthly', 'custom']
const fadeInSpeed = 500
const fadeOutSpeed = 0

class PaymentFormController extends ApplicationController {
  static targets = ['paymentType', 'intervalType', 'paymentDate', 'paymentStartDate', 'datevBsNr', 'datevLaEigene',
    'factorKey', 'tax', 'socialInsurance']

  connect () {
    Forms.initDatePickers('#hidden-side')
    Forms.initCheckbox('#hidden-side')
    Forms.initSelect2('#hidden-side')
    Forms.initCurrencyInputs('#hidden-side')

    this.handlePaymentTypeChange()

    $('#payment_payment_type_id').on('change', () => {
      this.handlePaymentTypeChange()
    })

    this.intervalTypeTarget.addEventListener('selected', () => {
      this.handlePaymentRecurrenceChange()
    })
  }

  handlePaymentTypeChange = () => {
    if (this.isPaymentRecurrent()) {
      $(this.intervalTypeTarget).val('monthly')
      $(this.intervalTypeTarget).trigger('change')
      this.intervalTypeTarget.readOnly = true
      $(this.intervalTypeTarget).select2('readonly', true)

      this.handlePaymentRecurrenceChange()

      $('.payment_amount .input-group-addon').fadeOut(fadeOutSpeed)
      document.querySelector('#recurrent-payment-fields').style.display = 'flex'
      if (this.hasPaymentDateTarget) { this.paymentDateTarget.disabled = true }
    } else {
      this.intervalTypeTarget.readOnly = false
      $(this.intervalTypeTarget).select2('readonly', false)

      $('.payment_amount .input-group-addon').fadeIn(fadeInSpeed)
    }

    if (this.hasDatevBsNrTarget && !this.datevBsNrTarget.value) {
      this.datevBsNrTarget.value = this.paymentTypeTarget.selectedOptions[0].dataset.datevBsNr || ''
    }
    if (this.hasDatevLaEigeneTarget && !this.datevLaEigeneTarget.value) {
      this.datevLaEigeneTarget.value = this.paymentTypeTarget.selectedOptions[0].dataset.datevLaEigene || ''
    }
    if (this.hasFactorKeyTarget && !this.factorKeyTarget.value) {
      this.factorKeyTarget.value = this.paymentTypeTarget.selectedOptions[0].dataset.factorKey || ''
    }
    if (this.hasTaxTarget && !this.taxTarget.value) {
      this.taxTarget.value = this.paymentTypeTarget.selectedOptions[0].dataset.tax || ''
    }
    if (this.hasSocialInsuranceTarget && !this.socialInsuranceTarget.value) {
      this.socialInsuranceTarget.value = this.paymentTypeTarget.selectedOptions[0].dataset.socialInsurance || ''
    }

    if (this.paymentTypeTarget.getAttribute('readonly') === 'readonly') {
      $(this.paymentTypeTarget).select2('readonly', true)
    }

    if (this.intervalTypeTarget.getAttribute('readonly') === 'readonly') {
      $(this.intervalTypeTarget).select2('readonly', true)
    }
  }

  handlePaymentRecurrenceChange = () => {
    if (this.isIntervalRecurrent()) {
      $('#one-time-payment-fields').fadeOut(fadeOutSpeed, () => {
        $('#recurrent-payment-fields').fadeIn(fadeInSpeed)
        if (this.hasPaymentDateTarget) { this.paymentDateTarget.disabled = true }
        this.paymentStartDateTarget.required = true
      })

      if (this.isIntervalCustom()) {
        $('#custom-recurrent-fields').fadeIn(fadeInSpeed)
      } else {
        $('#custom-recurrent-fields').fadeOut(fadeInSpeed)
      }
    } else {
      $('#recurrent-payment-fields').fadeOut(fadeOutSpeed, () => {
        $('#one-time-payment-fields').fadeIn(fadeInSpeed)
        this.paymentDateTarget.disabled = false
        this.paymentStartDateTarget.required = false
      })
    }
  }

  isPaymentRecurrent () {
    const selectedPaymentType = this.paymentTypeTarget.selectedOptions[0].dataset.type

    return SALARY_PAYMENT_TYPES.indexOf(selectedPaymentType) !== -1
  }

  isIntervalRecurrent () {
    const selectedIntervalType = this.intervalTypeTarget.selectedOptions[0].value

    return RECURRENT_INTERVALS.indexOf(selectedIntervalType) !== -1
  }

  isIntervalCustom () {
    return this.intervalTypeTarget.selectedOptions[0].value === 'custom'
  }
}

export default PaymentFormController
